/**
 * @flow
 * @relayHash b1a1a5fe89abd43e0f1652fb0cebecd5
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type GraphQLExplorerExamples_viewer$ref = any;
export type GraphQLExplorerExamplesQueryVariables = {||};
export type GraphQLExplorerExamplesQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: GraphQLExplorerExamples_viewer$ref
  |}
|};
export type GraphQLExplorerExamplesQuery = {|
  variables: GraphQLExplorerExamplesQueryVariables,
  response: GraphQLExplorerExamplesQueryResponse,
|};
*/


/*
query GraphQLExplorerExamplesQuery {
  viewer {
    ...GraphQLExplorerExamples_viewer
    id
  }
}

fragment GraphQLExplorerExamples_viewer on Viewer {
  organizations(first: 100) {
    edges {
      node {
        id
        name
        slug
        permissions {
          pipelineView {
            allowed
            code
          }
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "GraphQLExplorerExamplesQuery",
  "id": null,
  "text": "query GraphQLExplorerExamplesQuery {\n  viewer {\n    ...GraphQLExplorerExamples_viewer\n    id\n  }\n}\n\nfragment GraphQLExplorerExamples_viewer on Viewer {\n  organizations(first: 100) {\n    edges {\n      node {\n        id\n        name\n        slug\n        permissions {\n          pipelineView {\n            allowed\n            code\n          }\n        }\n      }\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "GraphQLExplorerExamplesQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "GraphQLExplorerExamples_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "GraphQLExplorerExamplesQuery",
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "organizations",
            "storageKey": "organizations(first:100)",
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 100,
                "type": "Int"
              }
            ],
            "concreteType": "OrganizationConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "OrganizationEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Organization",
                    "plural": false,
                    "selections": [
                      v0,
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "name",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "slug",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "permissions",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "OrganizationPermissions",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "pipelineView",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Permission",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "allowed",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "code",
                                "args": null,
                                "storageKey": null
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          v0
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'c64c9bf337bb61805129df834dfc9a5e';
module.exports = node;
